import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { SmoothScroll, ScrollToTop } from "@/components/motion/SmoothScroll";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Certifications from "@/pages/Certifications";
import Contact from "@/pages/Contact";
import BrandPage from "@/pages/BrandPage";
import Clara from "@/pages/Clara";
import CocoaGrade from "@/pages/CocoaGrade";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/certifications" element={<Certifications />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/brands/clara/products/:grade" element={<CocoaGrade />} />
              <Route path="/brands/clara" element={<Clara />} />
              <Route path="/brands/:slug" element={<BrandPage />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
